const retrievePermission = name => {
	return (state, storeState) => {
		if (storeState.me.personify.target.id !== '') return storeState.me.personify.target.userPermission[name];
		return storeState.me.permissions[name];
	};
};

export default retrievePermission;
